import React from 'react'
import Row from '@amzn/meridian/row'
import Text from '@amzn/meridian/text'
import Icon from '@amzn/meridian/icon'
import checkLargeTokens from '@amzn/meridian-tokens/base/icon/check-large'
import { IStoreFilterItemProps } from '../types'
import './StoreFilterItem.scss'

/**
 * StoreFilterItem Component
 *
 * Renders a single store row inside the StoreFilterSheet.
 * Displays the store name on the left and a check icon on the right when selected.
 * Tapping the row toggles the store's selection state.
 */
export const StoreFilterItem: React.FC<IStoreFilterItemProps> = ({
    store,
    isSelected,
    onToggle,
}) => {
    const handleClick = () => {
        onToggle(store.storeId)
    }

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === ' ') {
            e.preventDefault()
            handleClick()
        }
    }

    return (
        <div
            role="checkbox"
            tabIndex={0}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            className={`store-filter-item${isSelected ? ' selected' : ''}`}
            aria-checked={isSelected}
            aria-label={store.storeName}
        >
            <Row widths={['fill', 'fit']} width="100%" alignmentVertical="center">
                <Text color={isSelected ? 'inverted' : undefined}>{store.storeName}</Text>
                {isSelected && <span className="icon-inverted"><Icon tokens={checkLargeTokens} /></span>}
            </Row>
        </div>
    )
}
